import { Helmet } from "react-helmet-async";
import Sidebar from "../DesignSystem/Sidebar/Sidebar";
import AmlRows from "./Table/amlRows";

import "../../css/AMLDasboard.css";

const AMLDashboard = () => {
  return (
    <div className="Main-Page">
      <Helmet>
        <title>My Checks</title>
        <meta name="description" content="check²" />
      </Helmet>

      <Sidebar />

      <main className="Main-Container">
        <AmlRows />
      </main>
    </div>
  );
};

export default AMLDashboard;
